module.exports = __webpack_public_path__ + "img/icon_map_3_off_010.71c2dad9.png";